import React from 'react';
import styles from './style.module.css';
import Typography from '../../components/Typography/Typography';
import AnimatedButton from '../../components/AnimatedButton';
import AnimatedCard from '../../components/AnimatedCard';
import { HeroDressImage, HeroGallery, HeroVRHeadset } from '../../assets/webp';
import { VRHeadsetIcon } from '../../assets/svgs';
import { useNavigate } from 'react-router';

const HeroSection: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className={styles.heroContainer}>
      <div className={styles.heroContent}>
        <div className={styles.heroGrid}>
          <div className={styles.textContent}>
            <div className={styles.textWrapper}>
              <div className={styles.heroTitleWrapper}>
                <Typography
                  variant="heading1"
                  fontFamily="satoshi"
                  weight="bold"
                  className={styles.heroTitle}>
                  Experience the African market
                  like never before. Live the story behind every product.
                </Typography>
              </div>
              <div className={styles.heroSubtitleWrapper}>
                <Typography
                  variant="bodyRegular"
                  fontFamily="helvetica"
                  weight="regular"
                  className={styles.heroSubtitle}>
                  Redefining the shopping feel with
                  immersive experience
                </Typography>
              </div>
            </div>

            <div className={styles.buttonGroup}>
              <AnimatedButton
                variant="primary"
                onClick={() => navigate('/create-store')}
                className={styles.createShopButton}>
                <Typography
                  variant="buttonText"
                  fontFamily="satoshi"
                  weight="bold"
                  size="base"
                  className={styles.createShopText}>
                  Create Shop
                </Typography>
              </AnimatedButton>
              
              <AnimatedButton
                variant="secondary"
                onClick={() => navigate('/create-store')}
                className={styles.viewShopButton}>
                <Typography
                  variant="buttonText"
                  fontFamily="satoshi"
                  weight="bold"
                  size="base"
                  className={styles.viewShopText}>
                  View Shops
                </Typography>
              </AnimatedButton>
            </div>
          </div>

          <div className={styles.imageGrid}>
            <div className={styles.cardGrid}>
              <AnimatedCard
                className={`${styles.card} ${styles.clothingCard}`}
                delay={200}
                hoverEffect={true}
                floatAnimation={true}>
                <img
                  src={HeroDressImage}
                  alt="Fashionable Dress"
                  width={100}
                  height={100}
                  className={styles.dressImage}
                />
              </AnimatedCard>

              <AnimatedCard
                className={`${styles.card} ${styles.vrCard}`}
                delay={400}
                hoverEffect={true}
                floatAnimation={true}>
                <img
                  src={HeroVRHeadset}
                  alt="VR Headset"
                  width={100}
                  height={100}
                  className={styles.vrImage}
                />
                <div className={styles.vrIconContainer}>
                  <img
                    src={VRHeadsetIcon}
                    alt="VR Icon"
                    width={100}
                    height={100}
                    className={styles.vrIcon}
                  />
                </div>
              </AnimatedCard>

              <AnimatedCard
                className={`${styles.card} ${styles.galleryCard}`}
                delay={600}
                hoverEffect={true}
                floatAnimation={true}>
                <img
                  src={HeroGallery}
                  alt="Gallery Section"
                  width={100}
                  height={100}
                  className={styles.galleryImage}
                />
              </AnimatedCard>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HeroSection;